import { Star } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const REVIEWS = [
  {
    quote: "Polite, tidy and the finish is faultless — we wouldn't use anyone else.",
    who: "Homeowner, Bromsgrove",
  },
  {
    quote: "They transformed our rental between tenancies — fast, professional and easy to deal with.",
    who: "Landlord, Birmingham",
  },
  {
    quote: "Reliable for our contracted maintenance — always on site when they said they would be.",
    who: "Estate agent, Worcestershire",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-28 bg-[#121212] border-y border-white/10">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <Reveal className="text-center mb-14">
          <Eyebrow className="mb-4">Word of mouth</Eyebrow>
          <h2 className="font-serif text-4xl md:text-6xl text-[#f5f5f0] leading-tight">
            What our clients <em className="italic text-[#c5832b]">say.</em>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.who} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="h-full bg-[#1a1a1a] border border-white/10 hover:border-[#c5832b]/50 rounded-[2px] p-7 md:p-8 flex flex-col transition-colors duration-500"
              >
                <div className="flex gap-1 text-[#c5832b] mb-5" aria-label="5 out of 5 stars">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={15} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <blockquote className="font-serif italic text-lg md:text-xl text-[#f5f5f0] leading-relaxed flex-1">
                  "{r.quote}"
                </blockquote>
                <figcaption className="mt-6 text-xs uppercase tracking-[0.2em] text-[#a3a3a3]">
                  {r.who}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
